import { render, staticRenderFns } from "./tabs-aprobados.vue?vue&type=template&id=4175eb78&scoped=true"
import script from "./tabs-aprobados.vue?vue&type=script&lang=js"
export * from "./tabs-aprobados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175eb78",
  null
  
)

export default component.exports